/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
 */
import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName";

import clientDetailsRoutes from "@/router/recoveryCoaching/clients/clientDetailsRoutes";

let EmptyRouterView = () => import(/* webpackChunkName: "ClientsModule" */ '@/core/components/EmptyRouterView.vue')
let ClientCrmMain = () => import(/* webpackChunkName: "ClientManagement" */  "@/core/recoveryCoachingApp/coach/clients/ClientListMain/ClientCrmMain.vue");

// let CoachingMain = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/CoachingMain.vue')
// let CoachingProcessList = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Processes/CoachingProcessList.vue')
// let ProgramTemplateList = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Templates/ProgramTemplateList.vue')
// let CoachingProcessDetails = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Processes/CoachingProcessDetails.vue')
// let CoachingTemplateDetails = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Templates/ProgramTemplateDetails.vue')
// let CoachingProcessDetails = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Processes/CoachingProcessDetails')
// let CoachingTemplateDetails = () => import(/* webpackChunkName: "Login" */ '@/core/client/coach/Coaching/Templates/CoachingTemplateDetails')


export default [

	{
		path: 'clients',
		component: EmptyRouterView,
		name: 'ClientListMainRoute',
		redirect: redirectByName('ClientListTabsRoute', {activeTab: 'first-tab'}),
		props: mergeProps,
		children: [

			{
				path: ':activeTab',
				component: ClientCrmMain,
				name: 'ClientListTabsRoute',
				props: mergeProps,
				children:[
				]
			},
			{
				path: 'potential',
				name: 'ClientListMainPotential',
				redirect: redirectByName('ClientListMainRoute', {activeTab: 'potential'}),
			},
			...clientDetailsRoutes,

		]
	},




]

